module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAARRJREFUSEu11r0OAUEQB/D/qLSIwr2JRKGR0FFc4dE8gYJEo1AqFF4EhaBRKI6Ru3AOe7szZ227O/Pbz8kSFI3bKJ/qwZjBo9pkt1CEgqSDH8gMoC4DF+A20GAiKIs8J6bFnJAJyWIE7lQn25VrZ6yQDXlhfCag58JyIQmiwYyQBpFiX1ARRIK9Qb8gLiyFfCA2LIF8InkY/QMxYXQMg7is9F0Prmg/g88UXZt0CBtdoDQjoFw0mS2OgWl1vxkmZ/QvLEWWiNJb5xvLIvFi3t6RL+wT+YJ8bKMJMUK/YHlILlQEsyFWSIO5ECckwSSICLJhUkQMmTANooKyGIB5UlaWiKRly/kL+kx0DINWZb9da5A4xx0ygtXgXHa1gQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/list.png
// module id = d/f2
// module chunks = 1